// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6811488b","787":"c78bd388"}[chunkId] + ".chunk.js";
};